export default __webpack_public_path__ + "static/media/class_x_medical_m.c2cb9108.png";